<form #OBJ_form="ngForm" class="form-horizontal">
	<!--Iterate over normal fields-->
	<ng-container *ngFor="let OBJ_config_field of OBJ_config_fields.fields">
		<ng-container [ngSwitch]="OBJ_config_field.type">
			<ng-container *ngSwitchCase="'input'">
				<tig-input [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_item"></tig-input>
			</ng-container>
			<ng-container *ngSwitchCase="'checkbox'">
				<tig-checkbox [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_item"></tig-checkbox>
			</ng-container>
			<ng-container *ngSwitchCase="'textarea'">
				<tig-textarea [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_item"></tig-textarea>
			</ng-container>
			<ng-container *ngSwitchCase="'select'">
				<tig-select [OBJ_field_config]="OBJ_config_field" [OBJ_data]="OBJ_assignment"></tig-select>
			</ng-container>
		</ng-container>
	</ng-container>
	<!--Iterate over assignments-->
	<ng-container *ngFor="let OBJ_assignment_config_field of OBJ_assignment_config.fields">
		<ng-container [ngSwitch]="OBJ_assignment_config_field.type">
			<ng-container *ngSwitchCase="'select'">
				<tig-assignment-select [OBJ_field_config]="OBJ_assignment_config_field" [OBJ_data]="findAssignmentByTitle(OBJ_assignment_config_field.name)"></tig-assignment-select>
			</ng-container>
			<ng-container *ngSwitchCase="'select_multiple'">
				<tig-assignment-select-multiple [OBJ_field_config]="OBJ_assignment_config_field" [OBJ_data]="findAssignmentByTitle(OBJ_assignment_config_field.name)"></tig-assignment-select-multiple>
			</ng-container>
			<ng-container *ngSwitchCase="'select_multiple_check'">
				<tig-assignment-select-multiple-check [OBJ_field_config]="OBJ_assignment_config_field" [OBJ_data]="findAssignmentByTitle(OBJ_assignment_config_field.name)"></tig-assignment-select-multiple-check>
			</ng-container>
		</ng-container>
	</ng-container>
</form>
